import React, { createContext, useState, ReactNode } from 'react';
import type { DashboardExperience } from 'amazon-quicksight-embedding-sdk';

interface DashboardContextType {
  dashboard: DashboardExperience | null;
  setDashboard: (dashboard: DashboardExperience | null) => void;
  title: string;
  setTitle: (title: string) => void;
  isLoading: boolean;
  setIsLoading: (loading: boolean) => void;
  error: string | null;
  setError: (error: string | null) => void;
  setParameters: (params: any[]) => Promise<void>;
}

export const DashboardContext = createContext<DashboardContextType | undefined>(undefined);

export const DashboardProvider = ({ children }: { children: ReactNode }) => {
  const [dashboard, setDashboard] = useState<DashboardExperience | null>(null);
  const [title, setTitle] = useState<string>('');
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const setParameters = async (params: any[]) => {
    if (!dashboard) return;
    try {
      await dashboard.setParameters(params);
    } catch (err) {
      console.error('Failed to set parameters:', err);
      setError('Failed to set parameters');
    }
  };

  const contextValue = React.useMemo(() => ({
    dashboard,
    setDashboard,
    title,
    setTitle,
    isLoading,
    setIsLoading,
    error,
    setError,
    setParameters,
  }), [dashboard, title, isLoading, error]);

  return (
    <DashboardContext.Provider value={contextValue}>
      {children}
    </DashboardContext.Provider>
  );
};